import Box from "@mui/material/Box";
import { Control } from "react-hook-form";
import { PatientFormValues } from "../patient-form.component";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import SelectFormField from "components/select-form-field";
import { PAYMENT_SOURCE_TYPE } from "constants/patients";

type PaymentSourceTypeProps = {
  control: Control<PatientFormValues, object>;
};

export default function PaymentSourceType({ control }: PaymentSourceTypeProps) {
  return (
    <Box display="flex" justifyContent="space-between">
      <ShieldOutlinedIcon sx={{ mt: "30px", mr: 1.5 }} color="action" />
      <SelectFormField
        name="payment_source_type"
        label="Payment Source"
        control={control}
        options={PAYMENT_SOURCE_TYPE.getOptions()}
      />
    </Box>
  );
}
